"use client";

import { InteractiveAudioWaveformTrack } from "./interactive-audio-waveform-track";
import type {
	InteractiveAudioSegmentRegion,
	InteractiveAudioSegmentVisualState,
} from "./types";

export const FIXTURE_FIVE_TOPIC_SEGMENTS: InteractiveAudioSegmentRegion[] = [
	{
		id: "seg-0",
		startPercent: 0,
		endPercent: 20,
		label: "Cover",
		cardIndex: 0,
	},
	{
		id: "seg-1",
		startPercent: 20,
		endPercent: 40,
		label: "Card 1",
		cardIndex: 1,
	},
	{
		id: "seg-2",
		startPercent: 40,
		endPercent: 60,
		label: "Card 2",
		cardIndex: 2,
	},
	{
		id: "seg-3",
		startPercent: 60,
		endPercent: 80,
		label: "Card 3",
		cardIndex: 3,
	},
	{
		id: "seg-4",
		startPercent: 80,
		endPercent: 100,
		label: "Card 4",
		cardIndex: 4,
	},
];

export function buildFixtureSegmentStates(): Record<
	string,
	InteractiveAudioSegmentVisualState
> {
	return FIXTURE_FIVE_TOPIC_SEGMENTS.reduce<
		Record<string, InteractiveAudioSegmentVisualState>
	>((accumulator, segment, index) => {
		accumulator[segment.id] = {
			id: segment.id,
			bufferedPercent: index <= 2 ? 100 : 40,
			displayRevealPercent: index <= 2 ? 100 : 55,
			bufferRevealSessionKey: 1,
			bufferRevealSessionStartMs: 0,
			waveformMode: index === 4 ? "static" : "live",
			waveformSeed: segment.id,
			waveformTimeline: null,
		};
		return accumulator;
	}, {});
}

export interface InteractiveAudioWaveformTrackFixtureProps {
	progressPercent?: number;
	maxSeekPercent?: number;
	continuationPercent?: number;
	interactive?: boolean;
	onSeekCommit?: (percent: number) => void;
	onSeekRejected?: () => void;
}

export function InteractiveAudioWaveformTrackFixture({
	progressPercent = 25,
	maxSeekPercent = 100,
	continuationPercent = 55,
	interactive = true,
	onSeekCommit = () => {},
	onSeekRejected = () => {},
}: InteractiveAudioWaveformTrackFixtureProps) {
	return (
		<div className="w-[480px] p-4">
			<InteractiveAudioWaveformTrack
				progressPercent={progressPercent}
				maxSeekPercent={maxSeekPercent}
				furthestConsumedPercent={maxSeekPercent}
				continuationPercent={continuationPercent}
				segments={FIXTURE_FIVE_TOPIC_SEGMENTS}
				segmentStates={buildFixtureSegmentStates()}
				showParticles
				interactive={interactive}
				onScrubPause={() => {}}
				onSeekCommit={onSeekCommit}
				onSeekRejected={onSeekRejected}
			/>
		</div>
	);
}
